import { createGlobalStyle, css } from 'styled-components'
import { DRAWN_ITEM_CLASS } from './components/DrawTool/DrawTool'
import {
  CLUSTER_ICON_CLASS,
  SELECTION_DETAIL_CLASS,
} from './components/DrawTool/useMapVisualizations'

export const PAWN_CLASS = 'pawnIcon'
export const MARKER_CLASS = 'markerIcon'

export const SharedMapStyles = createGlobalStyle`
  body {
    touch-action: none;
    overflow: hidden; // This will prevent the scrollBar on iOS due to navigation bar
    @media print {
      overflow: auto;
    }
  }

  .leaflet-container {
    cursor: default;
    display: flex;
  }

  .leaflet-control-zoom {
    font-family: "Amsterdam Sans", sans-serif;
    font-size: 32px;
    position: absolute;
    right: 4px;
    bottom: 0px;
  }

  .leaflet-control-zoom-in, .leaflet-control-zoom-out {
    background-color: white;
    width: 44px;
    height: 44px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out {
    font-family: "Amsterdam Sans", sans-serif;
    font-size: 32px;
    font-weight: 400;
  }

  .leaflet-touch .leaflet-control-layers, .leaflet-touch .leaflet-bar {
    border: none;
  }

  .leaflet-touch .leaflet-bar a {
    width: 44px;
    height: 44px;
    line-height: 38px;
    color: var(--blue)
  }

  .leaflet-bar a {
    color: var(--blue);
    border: 2px solid var(--blue);
    border-radius: 0 !important;
  }

  .leaflet-bar a:first-child {
    border-bottom: none;
  }

  .leaflet-bar a:last-child {
    border-top: 2px solid var(--greyMedium);
    border-bottom: 2px solid var(--blue);
  }

  .${PAWN_CLASS} {
    z-index: 1000 !important;
  }

  .${SELECTION_DETAIL_CLASS} {
    cursor: pointer !important;
  }

  .${DRAWN_ITEM_CLASS} {
    cursor: url('/assets/cursors/edit.cur'), auto
  }

  .${CLUSTER_ICON_CLASS} {
     background-color: #EC0000;
     background-size: 100%;
     border-radius: 50%;
     border: 3px solid;
     box-shadow: 1px 1px 2px black;
     color: #fff;
     display: flex;
     flex-direction: column;
     justify-content: center;
     cursor: zoom-in;

     div {
       text-align:center;
     }
   }
`

export const DesktopMapStyle = createGlobalStyle<{
  panoActive?: boolean
  smallMap: boolean
  loading: boolean
  panelActive?: boolean
}>`
  // Need to set the styled globally and not as a Styled Component as this will cause problems with leaflet calculating the map canvas / dimensions
  .leaflet-container {
    cursor: ${({ loading }) => (loading ? 'progress' : 'default')};
    transition-property: left, bottom;
    transition-duration: 0.25s;
    transition-timing-function: ease-in-out;

    ${({ panoActive, smallMap, panelActive }) =>
      panoActive
        ? css`
            // Panorama is active
            position: absolute;
            width: ${smallMap ? '310px' : `calc(100%${panelActive ? ' - var(--panelWidth)' : ''})`};
            height: ${smallMap ? '178px' : '50%'};
            bottom: ${smallMap ? '1.25rem' : 0};

            ${smallMap &&
            css`
              @media screen and (min-width: 90rem) {
                width: 465px;
                height: 267px;
              }
            `};
          `
        : css`
            // Panorama is not active
            position: relative;
            height: 100%;
            width: 100%;

            .leaflet-bottom {
              position: fixed;
            }
          `}

    ${({ panelActive, panoActive, smallMap }) =>
      panelActive
        ? css`
            left: ${panoActive && smallMap
              ? 'calc(var(--panelWidth) + 50px)'
              : `calc(var(--panelWidth)${panoActive ? '' : ' * 0.5'})`};
          `
        : css`
            left: ${panoActive && smallMap ? '2.5rem' : '0px'};
          `}

    @media print {
      min-height: ${({ smallMap, panoActive }) => (smallMap && panoActive ? 'initial' : '100vh')};
      page-break-after: always;
      left: 0;
      margin-left: 0;
      ${({ smallMap }) =>
        !smallMap &&
        css`
          display: none;
        `}
    }

    ${({ smallMap, panoActive }) =>
      smallMap &&
      panoActive &&
      css`
        z-index: 901;
        border: 1px solid #ccc;

        @media print {
          top: 0;
          left: initial;
          right: 0;
        }
      `}

    .leaflet-bottom .leaflet-control-scale {
      position: absolute;
      bottom: 5px;
      right: 50px;
    }
  }
`

export const MobileMapStyle = createGlobalStyle<{ showHeader: boolean }>`
  header {
    display: ${({ showHeader }) => (showHeader ? 'flex !important' : 'none !important')};
  }

  // Need to set the styled globally and not as a Styled Component as this will cause problems with leaflet calculating the map canvas / dimensions
  .leaflet-container {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;

    .leaflet-bottom {
      .leaflet-control-scale {
        margin-bottom: 1rem;
        margin-right: 5rem;
        display: flex;

        .leaflet-control-scale-line {
          border: 2px solid var(--dark);
          border-top: none;
          font-size: 0.75rem;
        }
      }
    }
  }
`
